import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { glossaryColumns } from "./Glossary.columns";
import { glossaryRows } from "./Glossary.data";

const GlossaryTable = () => {
  return (
    <DefaultDataGrid
      rows={glossaryRows}
      columns={glossaryColumns}
      loading={false}
      pageSizeOptions={[5, 10, 20, 100]}
      disableCellFocus
      initialState={{
        pagination: {
          paginationModel: { pageSize: 100 },
        },
      }}
    />
  );
};

export default GlossaryTable;
